import type { HTMLAttributes } from "react";
import { WithChildren } from "../../types";
import styles from "./Main.module.css";

type MainProps = WithChildren & HTMLAttributes<HTMLElement> & { onClick?: () => void; disabled?: boolean; };

const Main = ({ children, className, ...props }: MainProps) => (
  <main className={[styles.main, className].filter(Boolean).join(" ")} {...props}>
    {children}
  </main>
);

export default Main;
